
import { defineComponent } from 'vue';
import { FooterNav } from './Nav';

const isEmailContactVisible = false;

const footerItems = [
  {
    text: 'kontakt@mydr.pl',
    link: 'mailto:kontakt@mydr.pl',
    icon: 'envelope',
    isVisible: isEmailContactVisible,
  },
  {
    text: 'Polityka prywatności',
    link: '/static/mydr_privacy_policy.pdf',
    isVisible: true,
  },
  {
    text: 'Polityka cookies',
    link: '/static/mydr_cookies_policy.pdf',
    isVisible: true,
  },
];

export default defineComponent({
  name: 'Footer',
  components: {
    FooterNav,
  },
  data() {

    return {
      footerItems,
    };
  },
  computed: {
    visibleFooterItems() {

      return footerItems.filter(item => item.isVisible);
    },
  },
});
